import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppState } from '../store/app.state';
import { selectUser, selectCurrentTenantId } from '../store/auth/auth.selectors';
import * as AuthActions from '../store/auth/auth.actions';

/** Chiave localStorage per il tenant di contesto del super admin (pulizia contesto). */
export const SUPER_ADMIN_TENANT_STORAGE_KEY = 'welty_super_admin_tenant_id';

/**
 * Guard per le route della parte admin (main layout).
 * - Admin e operator: sempre consentito (comportamento invariato).
 * - Super admin: consentito solo se è stato selezionato un tenant (store o localStorage).
 *   Se non c'è tenant, reindirizza a /admin.
 */
export const superAdminTenantContextGuard: CanActivateFn = () => {
  const store = inject(Store<AppState>);
  const router = inject(Router);

  return store.select(selectUser).pipe(
    take(1),
    switchMap((user) => {
      if (!user || user.role !== 'super_admin') {
        return of(true);
      }
      return store.select(selectCurrentTenantId).pipe(
        take(1),
        map((tenantId) => {
          if (tenantId) {
            return true;
          }
          const saved =
            typeof localStorage !== 'undefined' &&
            localStorage.getItem(SUPER_ADMIN_TENANT_STORAGE_KEY);
          if (saved) {
            store.dispatch(AuthActions.setAdminContextTenant({ tenantId: saved }));
            return true;
          }
          router.navigate(['/admin']);
          return false;
        })
      );
    })
  );
};
